import type { HTMLAttributes, ReactNode } from "react";

export interface SectionHeaderProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  action?: ReactNode;
  headingLevel?: 1 | 2 | 3;
}

export function SectionHeader({
  title,
  description,
  eyebrow,
  action,
  headingLevel = 2,
  className,
  ...props
}: SectionHeaderProps) {
  const Heading = `h${headingLevel}` as const;

  return (
    <header {...props} className={["ui-section-header", className].filter(Boolean).join(" ")}>
      <div>
        {eyebrow ? <div className="ui-section-header__eyebrow">{eyebrow}</div> : null}
        <Heading className="ui-section-header__title">{title}</Heading>
        {description ? <p className="ui-section-header__description">{description}</p> : null}
      </div>
      {action ? <div className="ui-toolbar">{action}</div> : null}
    </header>
  );
}
